export default {
  total: "Total",
  add_products: "+ Add products",
  order_ahead: 'Order ahead only',

  error_messages: {
    outside_delivery_times: "Outside of delivery times",
  },
};
